<template>
<div class="addrListDialog" v-if="dialogVisible">
    <el-dialog @close='cancel' title="选择提货点" :visible.sync="dialogVisible" width="650px">
        <div class="right_main_box">
            <div class="search_box">
                <div class="innerbox">
                    <span>已选择<span class="tc-orange">{{selectedPpNum}}</span>个提货点</span>
                    <el-button @click="handleCheck" type="text" size="small">取消选择</el-button>
                </div>
                <div class="innerbox">
                    <el-input placeholder="输入团长名称/联系号码" v-model="param.key" clearable></el-input>
                    <el-button type="primary" @click="handelQuery" plain>搜索</el-button>
                </div>
            </div>
            <div class="add_goods_tabs_box">
                <el-table :data="tableData" style="width: 100%" :show-header="false" ref="multipleTable"
                          @select="handleSelectionChange" @row-click="handleRowChange">
                    <el-table-column type="selection" width="30" :selectable="selectable"></el-table-column>
                    <el-table-column label="头像">
                        <template slot-scope="scope">
                            <div class="goods_item_box">
                                <img class="headerImg" v-lazy="scope.row.objrolelogo" alt>
                                <div class="outbox">
                                    <div class="box">
                                        <span class="innerbox">{{scope.row.name}}</span>
                                        <span  class="innerbox">{{scope.row.objrolename}}</span>
                                        <!--<span class="tc-red right-innerbox">累计销售：{{scope.row.objrolename}}</span>-->
                                    </div>
                                    <div class="box">
                                        <span class="tc-grey innerbox">{{scope.row.address}}</span>
                                        <!--<span class="tc-orange innerbox">团长佣金：{{scope.row.brokeragerateheader}}%</span>-->
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page" style="margin-top: 15px; text-align: center">
                <el-pagination
                    background
                    @current-change="handleSizeChange"
                    :current-page.sync="page.page"
                    :page-size="page.pageSize"
                    :pager-count="11"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
            <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="handleSure">确 定</el-button>
            </div>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {getPickupPointListByEvent} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'addrListDialog',
    data() {
        return {
            param: {
                eventid: '',
                key: '',
                pptype: '2',
                status: '1'
            },
            page: {
                page: 1,
                pageSize: 20,
                pageCount: 0
            },
            total: 0,
            dialogVisible: false,
            tableData: [],
            selectedResult: [],
            selectedPpNum: 0
        }
    },
    mounted() {
    },
    methods: {
        selectable(row, index) {
            return !!row.isdelete
        },
        handleCheck() {
            this.tableData.forEach(obj => {
                obj.isCheck = false
            })
            this.$refs.multipleTable.clearSelection()
            this.selectedResult = []
        },
        handleSizeChange() {
            this._getList()
        },
        openDialog(headerlist, eventid) {
            this.param.eventid = eventid
            this.tableData = []
            this.dialogVisible = true
            headerlist = this._.cloneDeep(headerlist)
            let tmplist = []
            headerlist.forEach((obj, i) => {
                if (obj.pplist) {
                    obj.pplist = obj.pplist.split(',')
                    tmplist.push(obj)
                    this.selectedPpNum = this.selectedPpNum + obj.pplist.length
                }
            })
            this.selectedResult = tmplist
            this._getList()
        },
        cancel() {
            this.selectedPpNum = 0
            this.param.key = ''
            this.page = {
                page: 1,
                pageSize: 20,
                pageCount: 0
            }
            this.selectedResult = []
            this.dialogVisible = false
        },
        handelQuery() {
            this.page.page = 1
            this.tableData = []
            this._getList()
        },
        _getList() {
            this.setLoading(true)
            getPickupPointListByEvent({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    data.data.datalist.forEach(obj => {
                        obj.isCheck = false
                    })
                    this.tableData = data.data.datalist
                    this.$nextTick(() => {
                        this.selectedResult.forEach((obj,i) => {
                            obj.pplist.forEach(obj1 => {
                                this.tableData.forEach((obj2,j) => {
                                    if (obj1 === obj2.ppinnerid) {
                                        obj2.isCheck = true
                                        this.$refs.multipleTable.toggleRowSelection(this.tableData[j])
                                        return false
                                    }
                                })
                            })
                        })
                    })
                    this.total = data.data.pageinfo.rowCount
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        handleSelectionChange(selection, row) {
            row.isCheck = !row.isCheck
            this._changeSelection(row)
        },
        handleRowChange(row) {
            row.isCheck = !row.isCheck
            if (row.isCheck) {
                this.$refs.multipleTable.toggleRowSelection(row)
            } else {
                this.$refs.multipleTable.toggleRowSelection(row, false)
            }
            this._changeSelection(row)
        },
        _changeSelection(row){
            if (row.isCheck) {
                let flag = true
                this.selectedResult.forEach((obj1, i) => {
                    if (obj1.headerid === row.objroleid) {
                        obj1.pplist.push(row.ppinnerid)
                        flag = false
                        return false
                    }
                })
                if (flag) {
                    this.selectedResult.push({headerid: row.objroleid, pplist: [row.ppinnerid]})
                }
                this.selectedPpNum++
            } else {
                this.selectedResult.forEach((obj1, i) => {
                    if (obj1.headerid === row.objroleid) {
                        obj1.pplist.forEach((obj2, j) => {
                            if (obj2 === row.ppinnerid) {
                                obj1.pplist.splice(j, 1)
                                return false
                            }
                        })
                    }
                    if (!obj1.pplist.length) {
                        this.selectedResult.splice(i, 1)
                    }
                })
                this.selectedPpNum--
            }
        },
        // 确定添加商品
        handleSure() {
            if (!this.selectedResult.length) {
                this.$message.error('请选择提货点')
                return false
            }
            let tmp = this._.cloneDeep(this.selectedResult)
            tmp.forEach(obj => {
                obj.pplist = obj.pplist.join(',')
            })
            this.$emit('setAddrList', tmp)
            this.cancel()
        },
        ...mapActions([
            'setLoading', 'setBrandBusiness'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user', 'brandBusiness'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.addrListDialog{
    display: flex;
    .right_main_box{
        width: 100%;
    }
    .search_box {
        display: flex;
        margin-bottom: 10px;
        justify-content: space-between;
        .innerbox{
            display: flex;
            align-items: center;
        }
        .el-input {
            width: 240px;
        }
        .el-input__inner {
            height: 32px;
        }
        .el-input__icon {
            line-height: 32px;
        }
        .el-button,
        .el-button--mini {
            height: 32px;
            width: 96px;
            margin-left: 20px;
            margin-bottom: 0px;
        }
    }
    .add_goods_tabs_box {
        .el-table {
            min-height: 340px;
        }
        .goods_item_box {
            display: flex;
            align-items: center;
            height: 42px;
            box-sizing: border-box;
            .headerImg{
                width: 50px;
                height: 50px;
                margin-right: 20px;
            }
            .innerbox{
                margin-right: 20px;
            }
            .outbox{
                flex-grow: 1;
                .box{
                    display: flex;
                    .right-innerbox{
                        flex-grow: 1;
                        text-align: right;
                    }
                }
            }
        }
        .el-table__empty-block {
            height: 340px;
            max-height: 340px;
        }
        .el-table__empty-text {
            position: relative;
            top: 80px;
        }
    }
    .el-table::before {
        height: 0;
    }
    .el-table__body-wrapper{
        height: 350px;
        overflow-y: auto !important;
    }
}
</style>
